module.exports = __webpack_public_path__ + "static/media/bg_header.9750c8f3.svg";